import * as rrd from 'react-router-dom';
import { useRef, useState, useEffect } from 'react';

import { CONVERSION } from '@/constants';

import useIsActiveTab from './useIsActiveTab';

const { useLocation, useSearchParams } = rrd.default ?? rrd;

const { account } = CONVERSION;

const useConverterParams = (tab, options) => {
  const {
    restoreGuard = true,
    source: sourceConfig = {},
    target: targetConfig = {},
  } = options;

  const { pathname } = useLocation();
  const isActive = useIsActiveTab(tab);
  const [searchParams] = useSearchParams();

  const getInitial = (key, config) =>
    config.routeParam ||
    (isActive && searchParams.get(key)) ||
    config.default ||
    '';

  const [source, setSource] = useState(() =>
    getInitial('source', sourceConfig)
  );

  const [target, setTarget] = useState(() =>
    getInitial('target', targetConfig)
  );

  const restoredRef = useRef(
    restoreGuard && isActive && !!searchParams.get('source')
  );

  useEffect(() => {
    if (restoredRef.current) {
      window.history.replaceState(null, '', window.location.pathname);
    }
  }, []);

  useEffect(() => {
    if (restoredRef.current) {
      restoredRef.current = false;
      return;
    }

    if (!pathname.endsWith(`/${tab}`)) return;

    const buildSearch = () => {
      if (tab === account) {
        if (sourceConfig.routeParam || !source || !target) {
          return null;
        }

        return `source=${source}&target=${target}`;
      }

      if (!source) return null;

      const params = new URLSearchParams();

      params.set('source', source);

      if (!targetConfig.routeParam && target) {
        params.set('target', target);
      }

      return params.toString();
    };

    const search = buildSearch();

    if (search) {
      window.history.replaceState(null, '', `${pathname}?${search}`);
    } else {
      window.history.replaceState(null, '', pathname);
    }
  }, [source, target, pathname]);

  return { source, target, isActive, setSource, setTarget };
};

export default useConverterParams;
